import { toGoogleMapLatLng, toGoogleMapLatLngBounds } from '@lib/geo/google/map';
import { SnLonLat, SnLonLatBounds } from '@lib/geo/helpers';

import { IGoogleGeocoderRequest } from '../interfaces';

export function toGoogleGeocoderRequest(
  request: IGoogleGeocoderRequest,
): google.maps.GeocoderRequest {
  const geocoderRequest: google.maps.GeocoderRequest = {};

  Object.keys(request).forEach((key) => {
    const value = request[key];

    if (!value) {
      return;
    }

    switch (key) {
      case 'lonLat':
        const lonLat = SnLonLat.convert(value);
        geocoderRequest.location = toGoogleMapLatLng(lonLat);
        break;

      case 'lonLatBounds':
        const lonLatBounds = SnLonLatBounds.convert(value);
        geocoderRequest.bounds = toGoogleMapLatLngBounds(lonLatBounds);
        break;

      default:
        geocoderRequest[key] = value;
    }
  });

  return geocoderRequest;
}
